/**
* User
*/

class User {

    constructor(document) {
        const data = document.data()

        this.uid = document.id
        this.firstName = data.firstName ? data.firstName : ''
        this.lastName = data.lastName ? data.lastName : ''
        this.hasCompletedOnboarding = data.hasCompletedOnboarding ? data.hasCompletedOnboarding : false
        this.isExpert = data.isExpert ? data.isExpert : false
    }

    get data() {
        return {
            uid: this.uid,
            firstName: this.firstName,
            lastName: this.lastName,
            hasCompletedOnboarding: this.hasCompletedOnboarding,
            isExpert: this.isExpert
        }
    }

}

export default User;